<template src="./SubirArchivoV2.html"></template>

<script>
import Icono from "../Icono/Icono";
import {
  respuesta_opciones,
  respuesta_crear,
  respuesta_leer
} from "./MocksSubirArchivoV2";
import {
  obtenerOpcionesDocumentos,
  crearDocumentoInactivo,
  borrarDocumentoInactivo,
  actualizarArchivoEnDocumento,
  leerDocumento
} from "../../apiService/request/CrudDocumentos";
export default {
  name: "subir-archivo-v2",
  data() {
    return {
      btnSubirArchivo: true,
      opcionSeleccionada: null,
      claseSeleccionada: null,
      dialog: false,
      formClaseValid: false, 
      etapa: 1,
      banderaConsultando: false,
      opciones: null,//respuesta_opciones.data.opciones,
      tipo_esquema: null,
      documento: null,
      documentoResumen: null,
      archivoSeleccionado: null,
      iconoFormulario:
        "M17,18c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H18C17.4,19,17,18.6,17,18z M30,23H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,23,30,23z M30,29H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,29,30,29z M30,35H18c-0.6,0-1,0.4-1,1s0.4,1,1,1h12c0.6,0,1-0.4,1-1S30.6,35,30,35z M38,11l0,31c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V2c0-1.1,0.9-2,2-2h19c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.1,0.3,0.2l10,10c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1C38,10.8,38,10.9,38,11C38,11,38,11,38,11z M28,10h6.6L28,3.4V10z M36,42l0-30h-9c-0.6,0-1-0.4-1-1V2H8l0,40L36,42z M14,17h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,17,14,17z M14,23h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,23,14,23z M14,29h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,29,14,29z M14,35h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0.6,0,1-0.4,1-1S14.6,35,14,35z M44,0v44 M0,0v44",
      iconoCargar:
      "M35.9,18.2C35,11.3,29,6,22,6c-5.6,0-10.5,3.3-12.8,8.3C3.8,15.6,0,20.4,0,26c0,6.6,5.4,12,12,12h22c5.5,0,10-4.5,10-10C44,23.1,40.6,19.1,35.9,18.2z M34,36H12C6.5,36,2,31.5,2,26c0-4.8,3.4-8.9,8.1-9.8l0.5-0.1l0.2-0.5C12.7,11,17.1,8,22,8c6.3,0,11.5,4.9,12,11.1L34,20l0.8,0.1c4.1,0.4,7.2,3.8,7.2,8C42,32.4,38.4,36,34,36z M28.7,21.3c0.4,0.4,0.4,1,0,1.4C28.5,22.9,28.3,23,28,23s-0.5-0.1-0.7-0.3L23,18.4V31c0,0.6-0.4,1-1,1s-1-0.4-1-1V18.4l-4.3,4.3C16.5,22.9,16.3,23,16,23s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l6-6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.5-0.1,0.8,0c0.1,0.1,0.2,0.1,0.3,0.2L28.7,21.3zM0,0h44 M44,44H0",
    };
  },
  props: {
    coleccionOrigen: {
      default: null,
      type: String
    },
    idOrigen: {
      type: String,
      default: null
    },
  },
  async mounted() {
    await this.obtenerListaOpciones();
  },
  computed: {
    clases(){
      if (this.documentoResumen && this.documentoResumen.variables && this.documentoResumen.variables[4].opciones_lista) {
        return this.documentoResumen.variables[4].opciones_lista;
      }
      return null;
    },
    c_momento() { // implementar lógica para detectar cambios cuando se usa el overlay
      return this.$store.getters.getMomentoActual;
    }
  },
    components: {
    Icono
  },
  methods: {
    async salirDialogo() {
      if (this.etapa > 1) {
        await this.borrarDocumento();
        this.limpiarInput();
        this.claseSeleccionada = null;
        this.opcionSeleccionada = null;
        this.documento = null;
        this.etapa = 1;
        this.banderaConsultando = false;
      }
    },
    async obtenerClases() {
      await this.crearDocumento();
      await this.leerDocumento();
      this.btnSubirArchivo=true;
    },
    async obtenerListaOpciones() {
      try {
        this.banderaConsultando = true;
        const respuesta = await obtenerOpcionesDocumentos();
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.opciones) {
          this.opciones = respuesta.data.data.opciones;
        } else {
          console.log('obtenerListaOpciones', respuesta);
        }
      } catch (err) {
        console.log("obtenerListaOpciones", err);
        this.banderaConsultando = false;
      } finally {
        this.banderaConsultando = false;
      }
    },
    async crearDocumento() {
      try {
        this.banderaConsultando = true;
        this.tipo_esquema = this.opcionSeleccionada.tipo_esquema;
        const respuesta = await crearDocumentoInactivo({
          tipo_esquema: this.opcionSeleccionada.tipo_esquema,
          documento: this.$store.getters.getCedulaPaciente,
          creado_por: this.$store.state.provider_email,
          origen: this.coleccionOrigen,
          momento: this.$store.getters.getMomentoActual ? `momento${this.$store.getters.getMomentoActual}` : null,
          id: this.idOrigen ? this.idOrigen : this.$store.getters.getId
        });
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.docId) {
          this.documento = respuesta.data.data;
        } else {
          console.log('crearDocumento', respuesta);
        }
      } catch (err) {
        console.log("crearDocumento", err);
      } finally {
        this.banderaConsultando = false;
      }
    },
    async leerDocumento() {
      try {
        this.banderaConsultando = true;
        const respuesta = await leerDocumento({
          tipo_esquema: this.opcionSeleccionada.tipo_esquema,
          docId: this.documento.docId
        });
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.variables) {
          this.documentoResumen = respuesta.data.data;
        }
      } catch (err) {
        console.log("leerDocumento", err);
      } finally {
        this.banderaConsultando = false;
      }
    },
    async borrarDocumento() {
      try {
        this.banderaConsultando = true;
        const respuesta = await borrarDocumentoInactivo(this.documento);
        if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.docId) {
          if (this.documento.docId === respuesta.data.data.docId) {
            this.doucumento = null;
            this.btnSubirArchivo = true;
          } else {
            console.log('borrarDocumento | ALERTA! documento borrado no coincide');
          }
        } else {
          console.log('borrarDocumento', respuesta);
        }
      } catch (err) {
        console.log("borrarDocumento", err);
      } finally {
        this.banderaConsultando = false;
      }
    },
    seleccionarArchivo() {
      if (this.$refs && this.$refs.inputArchivo && this.$refs.inputArchivo.files) {
        this.archivoSeleccionado = this.$refs.inputArchivo.files[0];
        console.log('archivo:', this.$refs.inputArchivo.files[0])
      if (this.archivoSeleccionado) {
        this.btnSubirArchivo = false
      }
      }
    },
    limpiarInput() {
      if (this.$refs && this.$refs.inputArchivo) {
        this.$refs.inputArchivo.value = null;
        this.archivoSeleccionado = null;
        this.btnSubirArchivo = true;
      }
    },
    async subirArchivo() {
      try {
        this.banderaConsultando = true;
        const respuesta = await actualizarArchivoEnDocumento({
          archivo: this.archivoSeleccionado,
          tipo_esquema: this.tipo_esquema,
          docId: this.documento.docId,
          documento: this.$store.getters.getCedulaPaciente,
          creado_por: this.$store.state.provider_email,
          variable5: this.claseSeleccionada.valor,
        });
        this.$root.$emit('archivoSubidoExitosamente', true);
        this.$store.dispatch('cambiarEstadoModal', true);
        this.$store.dispatch('cambiarMensajeModal', respuesta);
        this.dialog = false;
      } catch (err) {
        console.log(err);
        this.banderaConsultando = false;
      } finally {
        this.limpiarInput();
        this.claseSeleccionada = null;
        this.opcionSeleccionada = null;
        this.documento = null;
        this.etapa = 1;
        this.banderaConsultando = false;
      }
    }
  },
  watch: {
    async dialog(newValue, oldValue) {
      if (newValue === true) {
        if(!this.opciones) {
          await this.obtenerListaOpciones();
        }
      }
    }
  }
};
</script>

<style lang="scss" src="./SubirArchivoV2.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SubirArchivoV2/SubirArchivoV2.vue